import { css, keyframes } from '@emotion/react';

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  
  100% {
    opacity: 0;
  }
`;

export const fadeOutAnimation = (time?: number) => css`
  animation: ${fadeOut} ${time || 0.3}s ease-in-out;
`;
